import type { ReactNode } from "react";

import type { ClubView } from "../game/types";
import { useT } from "../i18n";
import { BotaoComGaveta } from "./BotaoComGaveta";
import { OfferCard } from "./MarketPanel";

/**
 * As propostas recebidas, ao lado da fila.
 *
 * Moravam no alto do Mercado, e só quem entrava lá via que havia dinheiro na
 * mesa esperando resposta. Agora é uma nota de dinheiro junto do botão de
 * jogar, com o número de propostas ainda sem resposta, e a lista abre por
 * cima com Aceitar e Recusar, como as notificações. A resposta entra na fila e
 * vale quando a rodada rodar.
 */
export function PropostasRecebidas({
  view,
  busy,
  onRespond,
}: {
  view: ClubView;
  busy: boolean;
  onRespond: (offerId: string, action: "aceitar" | "recusar") => void;
}): ReactNode {
  const t = useT();
  const total = view.offersIn.length;
  const semResposta = view.offersIn.filter((offer) => !view.pending.some((entry) => entry.offerId === offer.id)).length;

  return (
    <BotaoComGaveta
      icone="Propostas"
      rotulo={t("mercado.propostasRecebidas", { total })}
      conta={semResposta}
      classeDaConta="propostas-conta"
      nomeDoDialogo="Propostas recebidas"
    >
      {total === 0 ? (
        <p className="muted" style={{ margin: 0, padding: "16px 14px", fontSize: 12.5 }}>
          {t("mercado.semPropostasRecebidas")}
        </p>
      ) : (
        <div className="propostas-lista">
          {view.offersIn.map((offer) => (
            <OfferCard key={offer.id} offer={offer} view={view} busy={busy} onRespond={onRespond} incoming />
          ))}
        </div>
      )}
    </BotaoComGaveta>
  );
}
